export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7253.cfd69d84.jpg";